import * as React from 'react';
import * as _ from 'underscore';
import { componentRegistryEntry, createComponentRegistry, selectMigratedSettings } from '../../directives/tbSiteSettingsForServerAdminFormAdapter';
import ReactSiteSettingsForServerAdmin from './ReactSiteSettingsForServerAdmin';
import { SiteIdValidator } from './sections/site-name-and-id/SiteNameAndIdBusinessLogic';
import { SiteNameAndIdSection, SiteNameAndIdSpecs } from './sections/site-name-and-id/SiteNameAndIdSection';
import { SiteAvailabilitySpecs } from './sections/SiteAvailabilitySection';

/**
 * All react-based sections in the settings page should be added to this object to allow them to be named in
 * the pug file while migrating, and to dynamically load them later on
 */
// export const SettingsComponentRegistry: _.Dictionary<React.ComponentType> = {
//   SiteNameAndIdSection,
// };
export const SettingsComponentRegistry = createComponentRegistry(
  SiteNameAndIdSpecs,
  SiteAvailabilitySpecs
);

